import { faComment, faIdCard, faUser, faUserFriends, faUsersCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'next-i18next';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import VyTooltip from '../../../../common/VyTooltip';
interface MessagingSideMenuInterface {
  selectedTab: number;
  setSelectedTab: (index: 0 | 1 | 2 | 3 | 4) => void;
  isOpenConversation: boolean;
}
const MessagingSideMenu = ({ selectedTab, isOpenConversation, setSelectedTab }: MessagingSideMenuInterface) => {
  const registration = useSelector(({ common }) => common.eventRegistration);
  const { t } = useTranslation();
  const user = useSelector(({ common }) => common.user);
  const event = useSelector(({ common }) => common.event);
  const booths = useSelector(({ common }) => common.booths);
  const isMobilePreview = useSelector(({ common }) => common.isMobilePreview);

  const matchingOrgBooth = booths.find((b) => b.organization._id === user?.organization?._id);

  const twMessageTab = `w-full  grid justify-items-center cursor-pointer shadow hover:shadow-lg transition-all`;

  const twMessageTabStyle = {
    color: event?.template?.mainButtonTextColor ?? 'var(--scheme-main)',
    backgroundColor: event?.template?.mainColor ?? 'var(--scheme-main)',
  };

  return (
    <div
      className={`flex flex-row ${isMobilePreview ? '' : 'sm:flex-col'} items-center [&>div]:p-2 
    w-${isOpenConversation ? '0' : 'auto'} h-${isOpenConversation ? '0' : 'auto'}
    sm:w-[${isOpenConversation ? '0px' : isMobilePreview ? '100%' : '100px'}] sm:h-[${isMobilePreview ? 'auto' : isOpenConversation ? '0px' : '100%'}] 
    `}
      style={{ borderRight: '.2px solid gray' }}>
      <div
        className={`${twMessageTab} ${registration?.messagingGhostMode ? 'opacity-30' : ''} ${selectedTab === 0 && 'opacity-50'}`}
        onClick={() => setSelectedTab(0)}
        style={twMessageTabStyle}>
        <VyTooltip title={t('event:messaging.messages')} placement="right-start">
          <FontAwesomeIcon icon={faComment} size="2x" />
        </VyTooltip>
      </div>
      <div
        className={`${twMessageTab} ${registration?.messagingGhostMode ? 'opacity-30' : ''} ${selectedTab === 1 && 'opacity-50'}`}
        style={twMessageTabStyle}
        onClick={() => setSelectedTab(1)}>
        <VyTooltip title={t('event:messaging.participants')} placement="right-start">
          <FontAwesomeIcon icon={faUser} size="2x" />
        </VyTooltip>
      </div>
      {user?.role !== 'PARTICIPANT_ANONYM' && !!matchingOrgBooth && event?.settings.allowMessagingBoothVisitors && (
        <div className={`${twMessageTab} ${selectedTab === 2 && 'opacity-50'}`} onClick={() => setSelectedTab(2)} style={twMessageTabStyle}>
          <VyTooltip title={t('event:messaging.tooltip-booth-opens')} placement="right-start">
            <FontAwesomeIcon icon={faUserFriends} size="2x" />
          </VyTooltip>
        </div>
      )}
      {user?.role === 'PARTICIPANT_ANONYM' && (
        <div className={`${twMessageTab} ${selectedTab === 3 && 'opacity-50'}`} onClick={() => setSelectedTab(3)} style={twMessageTabStyle}>
          <FontAwesomeIcon icon={faUsersCog} size="2x" />
        </div>
      )}
      <div className={`${twMessageTab} ${selectedTab === 4 && 'opacity-50'}`} onClick={() => setSelectedTab(4)} style={twMessageTabStyle}>
        <VyTooltip title={t('event:messaging.contactshares-histroy')} placement="right-start">
          <FontAwesomeIcon icon={faIdCard} size="2x" />
        </VyTooltip>
      </div>
    </div>
  );
};
export default MessagingSideMenu;
